import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";
import { OfferYacht } from "../app/Bookings/model";

const updateBookingCustomerPricing = async (
  offerYachtId: string,
  body: {
    pricing: OfferYacht["pricing"];
    discountCharterPrice: OfferYacht["discountCharterPrice"];
  },
  bookingId: string,
) => {
  return fetch(`/api/bookings/${offerYachtId}/customer-pricing?bookingId=${bookingId}`, "PUT", body);
};

export const useBookingCustomerPricingMutation = (offerYachtId: string, bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (data: { pricing: OfferYacht["pricing"]; discountCharterPrice: OfferYacht["discountCharterPrice"] }) =>
      updateBookingCustomerPricing(offerYachtId, data, bookingId),
    onSuccess: () => {
      toast({
        title: "Success",
        description: "Customer pricing updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error.message || "Failed to update customer pricing section!",
        variant: "destructive",
      });
    },
  });
};
